// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uM9j","footer":"styles_footer__vH8l1","passCodeTooltip":"styles_passCodeTooltip__1f9Th"};